import { useCarrierOptions } from '#hooks/useCarrierOptions.js'

import { FilterTypeahead } from './adminFilters/FilterTypeahead'

type Props = {
  value: string
  onChange: (value: string) => void
}

export const ScacTypeahead = ({ value, onChange }: Props) => {
  const { options: carrierOptions } = useCarrierOptions()
  return (
    <FilterTypeahead
      label="SCAC"
      value={value}
      onChange={onChange}
      options={carrierOptions}
      placeholder="Type to search carriers..."
    />
  )
}
